import {
    BarChart3,
    Boxes,
    WalletCards,
    UsersRound,
    Scissors,
    ReceiptIndianRupee,
    IndianRupee,
    Calculator,
} from 'lucide-react';

// requiredAction: permission under "reports".
// altPermission:  optional [module, action] that also opens the item
//                 (so people who manage inventory see Inventory analytics even without a reports rule).
export const MENU_GROUPS = [
    {
        label: 'ANALYTICS',
        items: [
            { id: 'sales-analytics', title: 'Sales analytics', subtitle: 'Revenue movement', icon: BarChart3, kind: 'analytics', requiredAction: 'view_sales_analytics' },
            { id: 'outstanding-analytics', title: 'Outstanding', subtitle: 'Due and collections', icon: WalletCards, kind: 'analytics', requiredAction: 'view_outstanding_analytics' },
            { id: 'staff-analytics', title: 'Staff analytics', subtitle: 'Team performance', icon: UsersRound, kind: 'analytics', requiredAction: 'view_staff_analytics' },
            { id: 'inventory-analytics', title: 'Inventory analytics', subtitle: 'Stock in, out and profit', icon: Boxes, kind: 'analytics', requiredAction: 'view_inventory_analytics', altPermission: ['inventory', 'view'] },
            { id: 'service-analytics', title: 'Service analytics', subtitle: 'Demand and revenue', icon: Scissors, kind: 'analytics', requiredAction: 'view_service_analytics' },
        ],
    },
    {
        label: 'REPORTS',
        items: [
            { id: 'collection-report', title: 'Collection report', subtitle: 'Payments received', icon: WalletCards, kind: 'report', requiredAction: 'view_collection_report' },
            { id: 'billing-report', title: 'Billing report', subtitle: 'Invoices and sales', icon: ReceiptIndianRupee, kind: 'report', requiredAction: 'view_billing_report' },
            { id: 'gst-report', title: 'GST report', subtitle: 'Taxable sales and GST', icon: Calculator, kind: 'report', requiredAction: 'view_gst_report' },
            { id: 'expense-report', title: 'Expense report', subtitle: 'Costs and purchases', icon: IndianRupee, kind: 'report', requiredAction: 'view_expense_report' },
            { id: 'staff-payout-report', title: 'Staff payout report', subtitle: 'Commission and payout', icon: UsersRound, kind: 'report', requiredAction: 'view_staff_payout_report' },
        ],
    },
];

export const PERIODS = [
    { value: 'today', label: 'Today' },
    { value: 'thisWeek', label: 'This week' },
    { value: 'thisMonth', label: 'This month' },
    { value: 'lastMonth', label: 'Last month' },
    { value: 'thisYear', label: 'This year' },
];

/** Can this user open a menu item? */
export const canSeeItem = (item, hasPermission) => {
    if (typeof hasPermission !== 'function') return false;
    if (hasPermission('reports', item.requiredAction)) return true;
    if (Array.isArray(item.altPermission) && hasPermission(item.altPermission[0], item.altPermission[1])) return true;
    return false;
};